/**
 * Worker factory that isolates `import.meta.url` from the rest of the codebase.
 *
 * Jest cannot parse `import.meta.url`, so this module is mocked in tests
 * instead of trying to load the real Web Worker. All test files that need
 * a worker reference will mock this module:
 *
 *   jest.mock('../../voice/createKokoroWorker', () => require('./__tests__/createKokoroWorker.mock'));
 *
 * In production (CRA build), `new Worker(new URL(..., import.meta.url))` is
 * the supported pattern for loading module workers without ejecting.
 */
export function createKokoroWorker() {
  return new Worker(new URL('./kokoro-tts.worker.js', import.meta.url), { type: 'module' });
}
